import { createContext, useContext } from "react";

interface AdaChatContextValue {
  hasUnread: boolean;
  toggle: () => void;
}

export const AdaChatContext = createContext<AdaChatContextValue | null>(null);

/** Returns null when the Ada chatbot is not enabled for the current app/region. */
export function useAdaChat() {
  return useContext(AdaChatContext);
}
